// Labels that were stored in `timezone_metadata` before EX-6636 cleaned up the dropdown list.
// `findTimezoneByText` resolves them to the entry that replaced them, so legacy sends and one links
// still resolve to a zone. The stored UTC instant never changes; what is shown is that instant on the
// wall clock of the replacement entry's `utc[0]`. Where that zone has the same rules as the old entry's,
// legacy records keep the hour they were saved with. Where the old entry computed times in a zone that
// contradicted its own label (Vladivostok ran on Asia/Sakhalin, UTC+11; Magadan on Asia/Anadyr, UTC+12),
// the shown hour moves by one to the zone the label names. Keys are old labels, values are current labels.
export const timezoneAliases: Record<string, string> = {
  '(UTC-07:00) Pacific Daylight Time (US & Canada)': '(UTC-08:00) Pacific Time (US & Canada)',
  '(UTC-08:00) Pacific Standard Time (US & Canada)': '(UTC-08:00) Pacific Time (US & Canada)',
  '(UTC-04:00) Eastern Daylight Time (US & Canada)': '(UTC-05:00) Eastern Time (US & Canada)',
  '(UTC+01:00) Edinburgh, London': '(UTC) Edinburgh, London',
  // Both zones share the UTC/UTC+1 clock; only the letters differ, and the old entry ran on Atlantic/Canary.
  '(UTC) Dublin, Lisbon': '(UTC) Lisbon',
  '(UTC-02:00) Mid-Atlantic - Old': '(UTC-02:00) Coordinated Universal Time-02',
  '(UTC+12:00) Petropavlovsk-Kamchatsky - Old': '(UTC+12:00) Coordinated Universal Time+12',
  // The old entry computed times in America/Chihuahua, UTC-6 all year since 2022, and was the default for
  // every UTC-6 viewer in winter. The UTC-6 entry keeps those records on the hour they were saved with.
  '(UTC-07:00) Chihuahua, La Paz, Mazatlan': '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
  '(UTC-04:30) Caracas': '(UTC-04:00) Caracas',
  '(UTC-04:00) Asuncion': '(UTC-03:00) Asuncion',
  '(UTC-03:00) Greenland': '(UTC-02:00) Greenland',
  '(UTC + 1) Casablanca': '(UTC+01:00) Casablanca',
  '(UTC+01:00) Windhoek': '(UTC+02:00) Windhoek',
  '(UTC+02:00) Damascus': '(UTC+03:00) Damascus',
  '(UTC+03:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius':
    '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
  '(UTC+06:00) Nur-Sultan (Astana)': '(UTC+05:00) Nur-Sultan (Astana)',
  '(UTC+08:00) Krasnoyarsk': '(UTC+07:00) Krasnoyarsk',
  '(UTC+11:00) Vladivostok': '(UTC+10:00) Vladivostok',
  '(UTC+12:00) Magadan': '(UTC+11:00) Magadan',
};
